import { getCommandRequestData, getPathString } from '@helpers'
import { EXPAND_FIELD_PREFIX } from '@constants'
import { TimeLineDTOType } from '@types'

type Props = {
  config: TimeLineDTOType
}

export const getExpandsParamForColumnsObjectCommand = (props: Props) => {
  const {
    config: { objectX },
  } = props

  const command = objectX.columnsObject?.command

  const params = command?.parameters ? getCommandRequestData(command.parameters, {}) : {}

  const expands = typeof params['expands'] === 'string' ? params['expands']?.split(',') : []

  if (objectX.fieldFromColumnsObjectToLink?.length > 1) {
    const pathsForExpand = objectX.fieldFromColumnsObjectToLink.slice(0, -1)

    expands.push(
      `${getPathString(pathsForExpand)}:${getPathString(pathsForExpand, EXPAND_FIELD_PREFIX)}`
    )
  }

  if (
    objectX?.columnsObject?.headerField?.length &&
    objectX?.columnsObject?.headerField?.length > 1
  ) {
    const pathsForExpand = objectX?.columnsObject?.headerField.slice(0, -1)

    expands.push(
      `${getPathString(pathsForExpand)}:${getPathString(pathsForExpand, EXPAND_FIELD_PREFIX)}`
    )
  }

  return expands
}
